export const common = {
  /** 保有ポイントの表示（ヘッダーのポイント表示など） */
  pointAmount: (args: { amount: string | number }) => `${args.amount}pt`,
  // おかえりプラン（discover の訴求ダイアログ・purchase の訴求バナー）で共用する文言。
  // 価格・付与pt表示の文言はどちらの画面でも完全に同じ形式のためここに集約する
  comebackPromotion: {
    priceLabel: (args: { amount: string | number }) => `${args.amount}円`,
    pointLabel: (args: { point: string | number }) => `${args.point}pt`,
    normalPointLabel: (args: { point: string | number }) =>
      `通常${args.point}ptのところ`,
    remainingLabel: "残り",
    limitedBonusLabel: "今だけの限定購入ボーナス",
    purchaseSuffix: "のご購入で",
    pointSuffix: "もらえる！",
  },
  ok: "OK",
  yes: "はい",
  no: "いいえ",
  cancel: "キャンセル",
  save: "保存",
  delete: "削除",
  edit: "編集",
  close: "閉じる",
  back: "戻る",
  next: "次へ",
  confirm: "確認",
  send: "送信",
  loading: "読み込み中...",
  processing: "処理中...",
  error: "エラーが発生しました",
  unexpectedErrorMessage:
    "このユーザーは表示できません\nページを更新してください",
  cannotDisplayContent:
    "この情報を表示できません\n時間をおいてから再度お試しください",
  retry: "再試行",
  noData: "データがありません",
  search: "検索",
  menu: "メニュー",
  secondsAgo: (args: { count: string | number }) => `${args.count}秒前`,
  minutesAgo: (args: { count: string | number }) => `${args.count}分前`,
  hoursAgo: (args: { count: string | number }) => `${args.count}時間前`,
  daysAgo: (args: { count: string | number }) => `${args.count}日前`,
  videoAvailable: "利用可能",
  onlineNow: "オンライン中",
  recentlyOnline: "最近オンライン",
  offline: "オフライン",
  onlineStatus: "オンラインステータス",
  newUser: "新人",
  lovenseBadge: "遠隔バイブ対応",
  videoCallWaiting: "ビデオ通話可",
  voiceCallWaiting: "音声通話可",
  insufficientPoint: {
    title: "ポイント不足",
    description: (args: { actionName: string | number }) =>
      `ポイントが不足しているため、${args.actionName}を行えませんでした。\nポイント購入後に再度お試しください。`,
    purchaseButton: "ポイントを購入する",
  },
  pullToRefresh: {
    refreshing: "更新中...",
    release: "離して更新",
    pull: "引っ張って更新",
  },
} as const;
